import React, { useState } from "react";
import { Athlete, Rostergroup, TableAthlete } from "../../index";
import { DataTable } from "primereact/datatable";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { Button } from "primereact/button";
import RosterActionsMenu from "./RosterActionsMenu";
import GroupChip from "./GroupChip";
import { Toolbar } from "primereact/toolbar";
import AddAthleteModal from "../modal/AddAthleteModal";
import AddGroupsModal from "../modal/AddGroupModal";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { toast } from "react-toastify";
import AssignAthletesModal from "../modal/AssignAthletesModal";
import { InputText } from "primereact/inputtext";

interface Props {
  athletes: Athlete[];
}

const accept = () => {
  toast.success("Records deleted");
};

const reject = () => {
  toast.warning("Deletion cancelled");
};

const RosterTable = (props: Props) => {
  const [selectedAthletes, setSelectedAthletes] = useState<Athlete[]>([]);
  const [globalFilter, setGlobalFilter] = useState<string>("");

  const confirm2 = (event: React.MouseEvent<HTMLButtonElement>) => {
    confirmPopup({
      target: event.currentTarget,
      message: "Are you sure you want to delete athletes from roster?",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-start">
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => {
            const target = e.target as HTMLInputElement;
            console.log(target.value);
          }}
          placeholder="Search..."
        />
      </span>
    </div>
  );

  return (
    <div className="mb-5">
      <ConfirmPopup />
      <Toolbar
        start={
          <div className="flex gap-2">
            <AddAthleteModal />
            <AssignAthletesModal selectedAthletes={selectedAthletes} />
            <Button
              severity="danger"
              outlined
              icon="pi pi-trash"
              tooltip="Delete"
              tooltipOptions={{ position: "top" }}
              label="Delete"
              onClick={confirm2}
              disabled={selectedAthletes.length === 0}
            />
          </div>
        }
        end={
          <div className="flex gap-2">
            <Button
              label="Import roster"
              text
              icon="pi pi-download"
              className="w-min-content"
            />
            <AddGroupsModal iconButton={true} />
          </div>
        }
      ></Toolbar>
      <DataTable
        value={props.athletes}
        selectionMode="checkbox"
        selection={selectedAthletes}
        onSelectionChange={(e) => setSelectedAthletes(e.value)}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25]}
        globalFilter={globalFilter}
        globalFilterFields={["firstName", "lastName", "middleInitial"]}
        header={header}
      >
        <Column selectionMode="multiple" />
        <Column sortable field="firstName" header="First name" />
        <Column sortable field="middleInitial" header="M.I." />
        <Column sortable field="lastName" header="Last name" />
        <Column
          sortable
          header="Groups"
          className="w-3"
          body={GroupChip}
        ></Column>
        <Column sortable field="birthday" header="D.O.B" />
        <Column style={{ width: "5rem" }} body={<RosterActionsMenu />}></Column>
      </DataTable>
    </div>
  );
};

export default RosterTable;
